import { render, staticRenderFns } from "./invocieManage.vue?vue&type=template&id=d8524ba0&scoped=true"
import script from "./invocieManage.vue?vue&type=script&lang=js"
export * from "./invocieManage.vue?vue&type=script&lang=js"
import style0 from "./invocieManage.vue?vue&type=style&index=0&id=d8524ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8524ba0",
  null
  
)

export default component.exports